<template>
   <div class="help-bs">
       <v-card-title>{{$t('HelpBs.scientist_bs_applications')}}</v-card-title>
        <v-img
        max-width="600"
        src="../../../assets/help-bs/pasted image 1.png"></v-img>
        <v-card-subtitle>
            {{$t('HelpBs.interface_bs_role')}}:
        </v-card-subtitle>
        <v-card-title>{{$t('HelpBs.indicate_availability_experiment')}}</v-card-title>
        <v-card-subtitle>1. {{$t('HelpBs.requests_application_list')}}</v-card-subtitle>
        <v-img
        max-width="600"
        src="../../../assets/help-bs/Screenshot_1.png"></v-img>
        <v-img
        max-width="600"
        src="../../../assets/help-bs/Screenshot_7.png"></v-img>
        <v-card-title>{{$t('HelpBs.must_date_experiment')}}</v-card-title>
        <v-card-subtitle>2. {{$t('HelpBs.select_interval_request')}}
           {{$t('HelpBs.several_intervals_assigned')}} 
        </v-card-subtitle>
        <v-img
        max-width="600"
        src="../../../assets/help-bs/Screenshot_2.png"></v-img>
        <v-img
        max-width="600"
        src="../../../assets/help-bs/Screenshot_5.png"></v-img>
        <v-card-title>{{$t('HelpBs.list_experiments')}}</v-card-title>
        <v-card-subtitle>3. {{$t('HelpBs.displays_experiments_offered')}}</v-card-subtitle>
        <v-img
        max-width="600"
        src="../../../assets/help-bs/pasted image 4.png"></v-img>
        <v-card-text>
            {{$t('HelpBs.experiment_displayed_corner')}}
        </v-card-text>
   </div>
</template>
<script>
export default {
    name: 'BsHelp'
}
</script>
<style scoped>
.v-image {
    margin-bottom: 40px;
}
</style>